const relationId = (rel: any) => {
  if (rel == null || rel === "") {
    return null;
  }
  if (typeof rel === "object") {
    return rel.id ?? null;
  }
  return rel;
};

const dateOnly = (value: any) => {
  if (value == null || value === "") {
    return value;
  }
  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed.toISOString().split("T")[0];
};

/**
 * Console quote edit currently PUTs the in-memory quote object (nested company,
 * Date instances, quote_items with populated tasks). Send only writable fields
 * so changing `number` cannot 500 on unrelated nested relations.
 */
export const serializeQuoteWritePayload = (quote: any) => {
  if (!quote || typeof quote !== "object") {
    return {};
  }

  const number =
    quote.number == null || quote.number === ""
      ? quote.number
      : Number(quote.number);

  return {
    number,
    date: dateOnly(quote.date),
    currency: quote.currency,
    status: quote.status,
    body: quote.body,
    company: relationId(quote.company),
    base_rate: quote.base_rate,
    partial_invoicing: quote.partial_invoicing,
    expiration_date: dateOnly(quote.expiration_date),
    delivery_time: quote.delivery_time,
    expiration_days: quote.expiration_days,
    quote_items: Array.isArray(quote.quote_items)
      ? quote.quote_items.map((qi: any) => ({
          id: qi.id,
          price: qi.price,
          status: qi.status,
          title: qi.title,
          description: qi.description,
          order: qi.order,
          task: relationId(qi.task),
          subscription_item: qi.subscription_item
            ? { id: relationId(qi.subscription_item) }
            : null,
        }))
      : undefined,
  };
};
